export const EmptyTile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={"0 -0.5 16 16"}
      shape-rendering="crispEdges"
    >
      <metadata>
        Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj
      </metadata>
      <path
        stroke="#16181e"
        d="M0 0h1M5 1h10M14 2h1M14 3h1M14 4h1M0 5h1M14 5h1M14 6h1M0 7h1M14 7h1M0 8h1M14 8h1M0 9h1M14 9h1M0 10h1M14 10h1M0 11h1M0 12h1M0 13h1M0 14h1M0 15h9M10 15h1"
      />
      <path
        stroke="#222428"
        d="M1 0h1M0 1h1M2 1h3M0 2h1M0 3h1M0 4h1M0 6h1M14 11h1M14 12h1M14 13h1M9 15h1M11 15h2"
      />
      <path
        stroke="#333436"
        d="M2 0h1M1 1h1M2 2h12M2 3h12M2 4h12M2 5h12M2 6h12M2 7h12M2 8h12M2 9h12M2 10h12M2 11h12M2 12h12M2 13h12M13 14h2M13 15h2"
      />
      <path stroke="#3d3e40" d="M3 0h1M1 2h1M1 3h1M1 4h1M10 14h3M15 15h1" />
      <path
        stroke="#4b4c4e"
        d="M4 0h2M1 5h1M1 6h1M1 7h1M1 8h1M1 9h1M15 13h1M6 14h4M15 14h1"
      />
      <path stroke="#616266" d="M6 0h2M15 11h1M15 12h1" />
      <path
        stroke="#727377"
        d="M8 0h8M15 1h1M15 2h1M15 3h1M15 4h1M15 5h1M15 6h1M15 7h1M15 8h1M15 9h1M1 10h1M15 10h1M1 11h1M1 12h1M1 13h1M1 14h5"
      />
    </svg>
  );
};
